module.exports = __webpack_public_path__ + "img/silhouette-male.c81f3f7e.png";